import React, { useState, useEffect, useRef } from "react";
import { motion, useScroll, useTransform, AnimatePresence, useMotionValue, animate, useInView } from "framer-motion";
import flowersData from "./flowersData.json";
import emailjs from "@emailjs/browser";

import heroBanner from "./assets/homepage/hero_banner.webp";
import heroBanner2 from "./assets/homepage/hero_banner2.webp";
import heroBanner3 from "./assets/homepage/hero_banner3.webp";
import heroBanner4 from "./assets/homepage/hero_banner4.webp";
import gallery1 from "./assets/homepage/gallery_1.webp";
import gallery2 from "./assets/homepage/gallery_2.webp";
import gallery3 from "./assets/homepage/gallery_3.webp";
import shopWide from "./assets/homepage/shop_wide.webp";
import featureDarkBg from "./assets/homepage/feature_dark_bg.webp";
import featureBg2 from "./assets/homepage/feature_bg2.webp";
import featureBg3 from "./assets/homepage/feature_bg3.webp";
import teamWide from "./assets/homepage/team_wide.webp";
import product1 from "./assets/homepage/product_1.jpg";
import product2 from "./assets/homepage/product_2.jpg";
import product3 from "./assets/homepage/product_3.jpg";
import product4 from "./assets/homepage/product_4.jpg";
import aboutPhilosophyImg from './assets/homepage/aboutPhilosophy.webp';

const AnimatedNumber = ({ value }) => {
  const nodeRef = useRef(null);
  const motionValue = useMotionValue(0);
  
  // Làm tròn số trong quá trình chạy để không bị hiện số thập phân
  const rounded = useTransform(motionValue, (latest) => Math.round(latest));
  
  // Kiểm tra xem section đã hiển thị trên màn hình chưa
  const isInView = useInView(nodeRef, { once: true, margin: "-100px" });

  useEffect(() => {
    if (isInView) {
      // Khi lướt tới, số sẽ chạy từ 0 đến giá trị đích trong 2 giây
      const controls = animate(motionValue, value, {
        duration: 2,
        ease: "easeOut", // Chạy nhanh lúc đầu và chậm dần về cuối giống vòng quay số
      });
      return controls.stop;
    }
  }, [isInView, motionValue, value]);

  useEffect(() => {
    // Cập nhật text trực tiếp vào DOM để tránh re-render component liên tục, tối ưu hiệu năng
    const unsubscribe = rounded.on("change", (latest) => {
      if (nodeRef.current) {
        nodeRef.current.textContent = latest + "%";
      }
    });
    return unsubscribe;
  }, [rounded]);

  return <span ref={nodeRef}>0%</span>;
};

// Hàm helper lấy đường dẫn ảnh từ thư mục public/hoatrangchu
export const getFlowerImageUrl = (fileName) => {
  if (!fileName) return "";
  const cleanFileName = fileName.trim().replace(/\.[^/.]+$/, ""); 
  
  // Trỏ vào thư mục và gắn chuẩn đuôi .webp
  return `/hoatrangchu/${cleanFileName}.webp`; 
};

export default function LandingPage() {
  // --- STATE & DATA CHO HERO BANNER CAROUSEL ---
  const [currentHeroSlide, setCurrentHeroSlide] = useState(0);
  const HERO_AUTOPLAY_TIME = 6000;
  const heroSlides = [
    { id: 0, image: heroBanner, text: "FLORAISON | ĐẶT HOA ONLINE\nTHIẾT KẾ ĐỘC BẢN THEO MẪU", link: "/thiet-ke-bo-hoa" },
    { id: 1, image: heroBanner2, text: "MANG ĐẾN CẢM XÚC TRỌN VẸN\nQUA TỪNG NHÁNH HOA TƯƠI MỚI", link: "/mat-ngu-loai-hoa/theo-mau" },
    { id: 2, image: heroBanner3, text: "NGHỆ THUẬT CẮM HOA ĐƯƠNG ĐẠI\nSANG TRỌNG VÀ TINH TẾ", link: "/mat-ngu-loai-hoa/theo-y-nghia" },
    { id: 3, image: heroBanner4, text: "GIAO HOA NHANH TRONG 2 GIỜ\nPHỤC VỤ TOÀN TP.HCM", link: "/ve-chung-toi" },
  ];
const [promoEmail, setPromoEmail] = useState("");
const [isSubmitting, setIsSubmitting] = useState(false);

const handleNewsletterSubmit = async (e) => {
  e.preventDefault();

  if (!promoEmail) {
    // Hiện Toast cảnh báo
    setToast("Vui lòng nhập địa chỉ email của bạn! ⚠️");
    setTimeout(() => setToast(""), 4000);
    return;
  }

  setIsSubmitting(true);

  const templateParams = {
    customer_email: promoEmail,
    customer_name: "Khách hàng thân thiết", 
    reply_to: "floraison.hoa@gmail.com",
  };

  try {
    await emailjs.send(
      "service_pkqy3fq",     // Service ID
      "template_85mndcc",    // Template ID
      templateParams,
      "G7E9F24oqZjdEAUJx"    // Public Key
    );

    console.log("Email ưu đãi đã được gửi thành công! 🌸");
    
    // 🌸 Hiện Toast thành công xịn sò của Landing Page thay vì alert
    setToast("Đăng ký nhận đặc quyền ưu đãi thành công!");
    setTimeout(() => setToast(""), 4000); // Tự động ẩn sau 4 giây

    setPromoEmail(""); // Xóa trắng ô input
  } catch (error) {
    console.error("Lỗi gửi EmailJS (Newsletter):", error);
    
    // ❌ Hiện Toast lỗi hệ thống
    setToast("Có lỗi xảy ra trong quá trình gửi mail. Vui lòng thử lại sau!");
    setTimeout(() => setToast(""), 4000);
  } finally {
    setIsSubmitting(false);
  }
};

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentHeroSlide((prev) => (prev + 1) % heroSlides.length);
    }, HERO_AUTOPLAY_TIME);
    return () => clearInterval(timer);
  }, [heroSlides.length]);

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  // TỰ ĐỘNG MỞ POPUP & ĐỒNG BỘ TAB KHI TRUY CẬP BẰNG URL CHI TIẾT
useEffect(() => {
  const pathName = window.location.pathname.replace(/^\/+|\/+$/g, "").trim().toLowerCase();
  
  if (pathName && pathName !== "") {
    // 1. Dùng chung một hàm tạo Slug chuẩn cho cả 2 bên
    const standardSlugify = (str) => {
      if (!str) return "";
      return str
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[đĐ]/g, "d")
        .replace(/([^0-9a-z-\s])/g, "") // Xóa ký tự đặc biệt
        .replace(/(\s+|-+)/g, "-")      // Biến khoảng trắng thành gạch ngang
        .trim();
    };

    // 2. Tìm sản phẩm trong flowersData
    const matchedFlower = flowersData.find((flower) => {
      return flower["Tên"] && standardSlugify(flower["Tên"]) === pathName;
    });

    if (matchedFlower) {
      // BƯỚC QUAN TRỌNG: Mở popup hoa
      setSelectedFlower(matchedFlower);

      // BƯỚC CỨU CÁNH: Tìm xem hoa này thuộc mục nào trong Excel để chuyển Tab danh mục cho đúng
      const flowerCategoryInExcel = matchedFlower["Hoa ở mục nào"]?.trim().toLowerCase();
      
      // Khớp ngược lại sang ID của Tab hệ thống để giao diện không bị trống
      const targetCategory = categories.find(cat => {
        return getExcelCategoryName(cat.id).toLowerCase() === flowerCategoryInExcel;
      });

      if (targetCategory) {
        setActiveCategory(targetCategory.id); // Tự động nhảy sang Tab chứa bông hoa đó
      }
    } else {
      console.log("Không tìm thấy hoa phù hợp với URL:", pathName);
    }
  }
}, []);

  // --- STATE CHO DANH MỤC SẢN PHẨM & POPUP HOA ---
  const [activeCategory, setActiveCategory] = useState("banchay");
  const [hoveredId, setHoveredId] = useState(null);
  const [selectedFlower, setSelectedFlower] = useState(null);
  const [toast, setToast] = useState(null);

  const categories = [
    { id: "banchay", name: "Bán chạy nhất" },
    { id: "giamgia", name: "Đang giảm giá" },
    { id: "me", name: "Ngày của Mẹ" },
    { id: "totnghiep", name: "Hoa tốt nghiệp" },
    { id: "cuoi", name: "Hoa cưới" },
    { id: "matngu", name: "Mật ngữ loài hoa" },
    { id: "quatang", name: "Thiệp & Quà tặng" },
  ];

  // Map category tab ID sang tên thư mục tương ứng trong file Excel
  const getExcelCategoryName = (id) => {
    switch (id) {
      case "banchay": return "Bán chạy nhất";
      case "giamgia": return "Đang giảm giá";
      case "me": return "Ngày của mẹ";
      case "totnghiep": return "Hoa tốt nghiệp";
      case "cuoi": return "Hoa cưới";
      case "matngu": return "Mật ngữ loài hoa";
      case "quatang": return "Thiệp và quà tặng đi kèm";
      default: return "Bán chạy nhất";
    }
  };

  const currentExcelCategoryName = getExcelCategoryName(activeCategory);
  
  // Lọc data theo category
  const filteredFlowers = flowersData.filter(
    (flower) => flower["Hoa ở mục nào"]?.trim().toLowerCase() === currentExcelCategoryName.toLowerCase()
  );

  // Xử lý định dạng giá
  const formatPrice = (price) => {
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
  };

  // Logic Popup URL
  const openPopup = (flower) => {
  setSelectedFlower(flower);
  
  // Hàm tạo slug đồng bộ với useEffect ở trên
  const standardSlugify = (str) => {
    if (!str) return "";
    return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[đĐ]/g, "d").replace(/([^0-9a-z-\s])/g, "").replace(/(\s+|-+)/g, "-").trim();
  };
  
  const urlName = standardSlugify(flower["Tên"]);
  window.history.pushState(null, "", `/${urlName}`);
};

  const closePopup = () => {
    setSelectedFlower(null);
    window.history.pushState(null, "", "/");
  };

  // Hàm hiển thị toast notification
  const showToast = (message, duration = 2500) => {
    setToast(message);
    setTimeout(() => {
      setToast(null);
    }, duration);
  };

  // Hàm thêm sản phẩm vào giỏ hàng
  const addToCart = (flower) => {
    try {
      // Lấy giỏ hàng hiện tại từ localStorage
      const cart = JSON.parse(localStorage.getItem("sellixy_cart")) || [];

      // Tạo ID unique từ mã hoa
      const itemId = flower["Mã hoa"];

      // Kiểm tra item đã tồn tại trong giỏ
      const existingItem = cart.find((item) => item.id === itemId);

      if (existingItem) {
        // Nếu tồn tại, tăng quantity
        existingItem.quantity = (existingItem.quantity || 1) + 1;
      } else {
        // Nếu chưa tồn tại, thêm item mới
        const newItem = {
          id: itemId,
          name: flower["Tên"],
          price: flower["Giá sau khi giảm 25%"] || flower["Giá"],
          img: getFlowerImageUrl(flower["Mã hoa"]),
          ma: flower["Mã hoa"],
          quantity: 1,
        };
        cart.push(newItem);
      }

      // Lưu giỏ hàng vào localStorage
      localStorage.setItem("sellixy_cart", JSON.stringify(cart));

      // Dispatch custom event để MainLayout cập nhật badge
      window.dispatchEvent(new Event("cartUpdated"));

      // Đóng modal
      setSelectedFlower(null);
      window.history.pushState(null, "", "/");

      // Hiển thị toast notification
      showToast("✓ Đã thêm vào giỏ hàng");
    } catch (error) {
      console.error("Lỗi khi thêm vào giỏ hàng:", error);
      showToast("✕ Có lỗi xảy ra, vui lòng thử lại!");
    }
  };

  useEffect(() => {
    const handlePopState = () => setSelectedFlower(null);
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  // Khóa scroll nền khi mở popup
  useEffect(() => {
    if (selectedFlower) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [selectedFlower]);

  // --- STATE & DATA CHO FEATURE BANNER (ƯU ĐÃI) CAROUSEL ---
  const [currentFeatureSlide, setCurrentFeatureSlide] = useState(0);
  const FEATURE_AUTOPLAY_TIME = 4000;
  const featureSlides = [
    { id: 0, bg: featureDarkBg, text: "Giảm 15% cho đơn hàng đầu tiên.\nĐăng ký trải nghiệm ngay hôm nay." },
    { id: 1, bg: featureBg2, text: "Miễn phí giao hàng trong bán kính 5km\ntại khu vực nội thành HCM." },
    { id: 2, bg: featureBg3, text: "Giao hoa tận nơi nhanh chóng.\nCam kết hoa luôn tươi mới trong vòng 2 giờ." },
    { id: 3, bg: featureDarkBg, text: "Tư vấn chọn hoa Online.\nHỗ trợ thiết kế hoa theo mọi yêu cầu riêng biệt." },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentFeatureSlide((prev) => (prev + 1) % featureSlides.length);
    }, FEATURE_AUTOPLAY_TIME);
    return () => clearInterval(timer);
  }, [featureSlides.length]);

  // Lấy giá trị scroll để tạo hiệu ứng Parallax cho một số section
  const { scrollY } = useScroll();
  const parallaxY = useTransform(scrollY, [0, 2000], [0, -150]);

  // Inject Font chữ sang trọng (Google Fonts)
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Pinyon+Script&family=Montserrat:wght@200;300;400;500&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  return (
    <div style={styles.container}>
      <style>{`
        /* ================= RESPONSIVE DESIGN FOR MOBILE & TABLET ================= */

        /* Mobile: Small phones (< 480px) */
        @media (max-width: 480px) {
          /* Hero Section */
          .hero-section {
            height: 85vh !important;
          }

          .hero-overlay {
            padding: 0 0 50px 5% !important;
          }

          .hero-title {
            font-size: 18px !important;
            line-height: 1.4 !important;
            margin-bottom: 20px !important;
          }

          .hero-sub {
            font-size: 18px !important;
            margin-bottom: 2px !important;
          }

          .hero-btn {
            padding: 10px 20px !important;
            font-size: 9px !important;
          }

          .glass-nav-container {
            bottom: 20px !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
          }

          .timeline-wrapper {
            display: none !important;
          }

          /* Badge Section */
          .badge-grid {
            gap: 20px !important;
            padding: 40px 5% !important;
          }

          .badge-item {
            text-align: center;
          }

          .badge-title {
            font-size: 11px !important;
          }

          .badge-desc {
            font-size: 11px !important;
          }

          /* About Section */
          .about-grid {
            gap: 30px !important;
            padding: 60px 5% !important;
          }

          .about-text-col {
            padding-left: 0 !important;
          }

          .editorial-title {
            font-size: 22px !important;
          }

          .about-paragraph {
            font-size: 12px !important;
          }

          /* Metrics Section */
          .metrics-grid {
            gap: 30px !important;
            padding: 50px 5% !important;
          }

          .metric-card {
            border-right: none !important;
            border-bottom: 1px solid rgba(255,255,255,0.15) !important;
            padding: 20px 0 !important;
          }

          .metric-number {
            font-size: 40px !important;
          }

          .metric-label {
            font-size: 11px !important;
          }

          /* Wide Image Section */
          .wide-image-section {
            height: 50vh !important;
          }

          .center-logo-text {
            font-size: 40px !important;
          }

          /* Products Section */
          .products-section {
            padding: 60px 5% !important;
          }

          .category-tabs-container {
            gap: 12px !important;
            padding-bottom: 10px !important;
          }

          .category-tab-btn {
            font-size: 11px !important;
            padding: 6px 2px !important;
          }

          .products-grid {
            gap: 2px 2px !important;
            grid-template-columns: repeat(2, 1fr) !important;
          }

          /* Story Section */
          .story-section {
            padding: 60px 5% !important;
          }

          .script-title {
            font-size: 45px !important;
          }

          .story-subtitle {
            font-size: 18px !important;
          }

          .story-text {
            font-size: 12px !important;
            text-align: left !important;
          }

          /* Dark Feature Section */
          .dark-feature-section {
            padding: 80px 5% !important;
          }

          .feature-title {
            font-size: 20px !important;
          }

          .feature-glass-box {
            padding: 20px 20px !important;
            min-height: auto !important;
          }

          .feature-highlight-text {
            font-size: 13px !important;
          }

          /* Feedback Section */
          .feedback-section {
            padding: 60px 5% !important;
          }

          .feedback-grid {
            gap: 20px !important;
            grid-template-columns: 1fr !important;
          }

          .feedback-card {
            padding: 25px 20px !important;
          }

          .feedback-text {
            font-size: 12px !important;
          }

          /* Team Section */
          .team-section {
            height: 50vh !important;
          }

          /* Promo Section */
          .promo-section {
            padding: 60px 5% !important;
          }

          .promo-title {
            font-size: 20px !important;
          }

          .promo-desc {
            font-size: 12px !important;
          }

          .input-action-wrapper {
            flex-direction: column !important;
            gap: 12px !important;
          }

          .luxury-input {
            width: 100% !important;
          }

          .luxury-input-btn {
            width: 100% !important;
            font-size: 11px !important;
          }

          /* Modal */
          .modal-content {
            flex-direction: column !important;
            max-width: 95vw !important;
            height: auto !important;
            max-height: 90vh !important;
            display: flex !important;
            overflow: hidden !important;
          }

          .modal-image-col {
            flex: 0 0 auto !important;
            height: 300px !important;
            padding: 20px !important;
          }

          .modal-info-col {
            flex: 1 1 auto !important;
            padding: 30px 20px !important;
            overflow-y: auto !important;
            max-height: calc(90vh - 300px) !important;
          }

          .modal-title {
            font-size: 24px !important;
          }

          .modal-desc-text {
            font-size: 12px !important;
          }

          .add-to-cart-btn {
            font-size: 11px !important;
            padding: 14px 0 !important;
            margin-top: 20px !important;
          }

          .modal-section {
            margin-bottom: 20px !important;
          }

          .modal-section-title {
            font-size: 11px !important;
            margin-bottom: 10px !important;
          }

          .modal-price-box {
            margin-bottom: 20px !important;
          }

          .modal-divider {
            margin: 20px 0 !important;
          }

          .close-btn {
            top: 15px !important;
            right: 15px !important;
            font-size: 24px !important;
          }
        }

        /* Tablet: Medium devices (480px - 768px) */
        @media (max-width: 768px) and (min-width: 480px) {
          /* Hero Section */
          .hero-section {
            height: 90vh !important;
          }

          .hero-title {
            font-size: 22px !important;
          }

          .hero-overlay {
            padding: 0 0 60px 5% !important;
          }

          .glass-nav-container {
            bottom: 25px !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
          }

          .timeline-wrapper {
            display: none !important;
          }

          /* Badge Section */
          .badge-grid {
            gap: 30px !important;
            padding: 50px 5% !important;
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .badge-title {
            font-size: 11px !important;
          }

          .badge-desc {
            font-size: 12px !important;
          }

          /* About Section */
          .about-grid {
            gap: 40px !important;
            padding: 80px 5% !important;
            grid-template-columns: 1fr !important;
          }

          .about-text-col {
            padding-left: 0 !important;
          }

          .editorial-title {
            font-size: 26px !important;
          }

          .about-paragraph {
            font-size: 13px !important;
          }

          /* Metrics Section */
          .metrics-grid {
            gap: 35px !important;
            padding: 60px 5% !important;
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .metric-card {
            border-right: none !important;
            border-bottom: 1px solid rgba(255,255,255,0.15) !important;
            padding: 25px 0 !important;
          }

          .metric-number {
            font-size: 50px !important;
          }

          /* Wide Image Section */
          .wide-image-section {
            height: 55vh !important;
          }

          .center-logo-text {
            font-size: 55px !important;
          }

          /* Products Section */
          .products-section {
            padding: 80px 5% !important;
          }

          .category-tabs-container {
            gap: 18px !important;
            flex-wrap: wrap !important;
          }

          .products-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 3px 3px !important;
          }

          /* Story Section */
          .story-section {
            padding: 80px 5% !important;
          }

          .script-title {
            font-size: 55px !important;
          }

          .story-subtitle {
            font-size: 22px !important;
          }

          .story-text {
            font-size: 13px !important;
            text-align: left !important;
          }

          /* Dark Feature Section */
          .dark-feature-section {
            padding: 100px 5% !important;
          }

          .feature-text-left {
            max-width: 100% !important;
          }

          .feature-title {
            font-size: 26px !important;
          }

          .feature-glass-box {
            padding: 25px 30px !important;
          }

          /* Feedback Section */
          .feedback-section {
            padding: 80px 5% !important;
          }

          .feedback-grid {
            grid-template-columns: 1fr 1fr !important;
            gap: 25px !important;
          }

          .feedback-card {
            padding: 30px 25px !important;
          }

          /* Team Section */
          .team-section {
            height: 55vh !important;
          }

          /* Promo Section */
          .promo-section {
            padding: 80px 5% !important;
          }

          .promo-title {
            font-size: 24px !important;
          }

          .input-action-wrapper {
            flex-direction: column !important;
            max-width: 100% !important;
          }

          .luxury-input {
            width: 100% !important;
          }

          .luxury-input-btn {
            width: 100% !important;
          }

          /* Modal */
          .modal-content {
            flex-direction: column !important;
            max-width: 90vw !important;
            height: auto !important;
            max-height: 90vh !important;
          }

          .modal-image-col {
            flex: 0 0 auto !important;
            height: 350px !important;
            padding: 30px !important;
          }

          .modal-info-col {
            flex: 1 1 auto !important;
            padding: 40px 35px !important;
            overflow-y: auto !important;
            max-height: calc(90vh - 350px) !important;
          }

          .modal-title {
            font-size: 28px !important;
          }

          .modal-price-box {
            flex-wrap: wrap !important;
          }
        }

        /* Large Tablet & Small Desktop: 768px - 1024px */
        @media (max-width: 1024px) and (min-width: 768px) {
          .products-grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }

          .badge-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .modal-content {
            max-width: 85vw !important;
          }

          .input-action-wrapper {
            flex-direction: column !important;
            max-width: 100% !important;
            align-items: center !important;
          }

          .luxury-input {
            width: 100% !important;
            max-width: 400px !important;
          }

          .luxury-input-btn {
            width: 100% !important;
            max-width: 400px !important;
          }
        }

        /* Ensure viewport meta tag behavior */
        * {
          box-sizing: border-box;
        }
      `}</style>
      {/* 1. HERO BANNER - SLIDER ZOOM SÂU & KÍNH XUYÊN THẤU */}
      <motion.section style={styles.heroSection} className="hero-section">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentHeroSlide}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.5 }}
            style={{ width: "100%", height: "100%", position: "absolute" }}
          >
            <motion.img
              src={heroSlides[currentHeroSlide].image}
              alt="Floraison Banner"
              style={styles.heroImage}
              initial={{ scale: 1 }}
              animate={{ scale: 1.12 }}
              transition={{ duration: HERO_AUTOPLAY_TIME / 1000, ease: "linear" }}
            />
            <div style={styles.heroOverlay}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2, delay: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
                style={styles.heroTextContainer}
              >
                <span style={styles.heroSub}>Premium Flower Boutique</span>
                <h1 style={styles.heroTitle} className="hero-title">{heroSlides[currentHeroSlide].text}</h1>
                <motion.button
                  whileHover={{ scale: 1.05, backgroundColor: "#ffffff", color: "#111111" }}
                  whileTap={{ scale: 0.98 }}
                  style={styles.heroBtn}
                  className="hero-btn"
                  onClick={() => { window.location.href = heroSlides[currentHeroSlide].link; }}
                >
                  Khám phá bộ sưu tập
                </motion.button>
              </motion.div>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Nút điều hướng iOS xuyên thấu */}
        <div style={styles.glassNavContainer} className="glass-nav-container">
          {heroSlides.map((_, idx) => (
            <div
              key={idx}
              onClick={() => setCurrentHeroSlide(idx)}
              style={{
                ...styles.glassNavDot,
                width: currentHeroSlide === idx ? "32px" : "8px",
                backgroundColor: currentHeroSlide === idx ? "#ffffff" : "rgba(255,255,255,0.4)"
              }}
            />
          ))}
        </div>

        {/* Thanh thời gian góc dưới bên phải */}
        <div style={styles.timelineWrapper} className="timeline-wrapper">
          <motion.div
            key={currentHeroSlide}
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: HERO_AUTOPLAY_TIME / 1000, ease: "linear" }}
            style={styles.timelineBar}
          />
        </div>
      </motion.section>

      {/* 2. CHẤT LƯỢNG ĐIỆN HOA & ĐIỂM NHẤN TIN CẬY (CORE BADGES) */}
      <section style={styles.badgeSection}>
        <div style={styles.badgeGrid} className="badge-grid">
          <div style={styles.badgeItem}>
            <span style={styles.badgeIcon}>✦</span>
            <h4 style={styles.badgeTitle} className="badge-title">MIỄN PHÍ GIAO HÀNG</h4>
            <p style={styles.badgeDesc} className="badge-desc">{"Freeship TP.HCM bán kính 5km\ncho mọi đơn hàng"}</p>
          </div>
          <div style={styles.badgeItem}>
            <span style={styles.badgeIcon}>✦</span>
            <h4 style={styles.badgeTitle} className="badge-title">TẶNG THIỆP CAO CẤP</h4>
            <p style={styles.badgeDesc} className="badge-desc">{"Thiệp chúc mừng thiết kế tinh tế\nmiễn phí kèm theo"}</p>
          </div>
          <div style={styles.badgeItem}>
            <span style={styles.badgeIcon}>✦</span>
            <h4 style={styles.badgeTitle} className="badge-title">CỬA HÀNG TRUNG TÂM</h4>
            <p style={styles.badgeDesc} className="badge-desc">{"Mạng lưới dịch vụ giao hoa\nchuyên nghiệp tại TP.HCM"}</p>
          </div>
          <div style={styles.badgeItem}>
            <span style={styles.badgeIcon}>✦</span>
            <h4 style={styles.badgeTitle} className="badge-title">PHỤC VỤ 24/7</h4>
            <p style={styles.badgeDesc} className="badge-desc">{"Luôn luôn sẵn sàng lắng nghe\nvà tư vấn tận tình"}</p>
          </div>
        </div>
      </section>

      {/* 3. GIỚI THIỆU BACKGROUND VỀ SHOP (EDITORIAL SPLIT LAYOUT) */}
      <section style={styles.aboutSection}>
        <div style={styles.aboutGrid} className="about-grid">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            style={styles.aboutImgCol}
          >
            <img src={aboutPhilosophyImg} alt="Floraison Artistry" style={styles.aboutImage} />
            <div style={styles.aboutImgFloatingTag}>Since 2026</div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2 }}
            style={styles.aboutTextCol}
            className="about-text-col"
          >
            <span style={{ ...styles.editorialSub, textAlign: "left" }}>FLORAILOSOPHY</span>
            <h2 style={styles.editorialTitle} className="editorial-title">{"Triết lý về hoa\ncủa Floraison"}</h2>
            <p style={styles.aboutParagraph} className="about-paragraph">
              {"Floraison là tiệm hoa tươi mang phong cách hiện đại, tinh tế và cá nhân hóa,\nchuyên cung cấp các mẫu hoa thiết kế dành cho các dịp sinh nhật, khai trương,\nkỷ niệm. Với mong muốn thay bạn gửi gắm trọn vẹn yêu thương qua từng cánh hoa, Floraison luôn chú trọng từ chất lượng hoa tươi đến trải nghiệm\ndịch vụ chuyên nghiệp."}
            </p>
            <p style={styles.aboutParagraph} className="about-paragraph">
              {"Đặc biệt, khách hàng có thể tự tay thiết kế bó hoa trực tiếp trên website\ntheo sở thích riêng từ lựa chọn tone màu, kiểu dáng đến loại hoa yêu thích\ngiúp món quà mang đậm dấu ấn cá nhân. Đội ngũ florist sáng tạo luôn sẵn sàng\nđồng hành hỗ trợ, giúp bạn tạo nên những khoảnh khắc ý nghĩa\nvà đáng nhớ nhất."}
            </p>
            <motion.button
              whileHover={{ scale: 1.05, backgroundColor: "#111111", color: "#ffffff" }}
              whileTap={{ scale: 0.98 }}
              style={styles.classicLinkBtn}
              onClick={() => { window.location.href = "/ve-chung-toi"; }}
            >
              Xem chi tiết về chúng tôi ⟶
            </motion.button>
          </motion.div>
        </div>
      </section>

      {/* 4. SỐ LIỆU THỐNG KÊ (NUMERICAL METRICS SECTION) */}
<section style={styles.metricsSection}>
  <div style={styles.metricsGrid} className="metrics-grid">
    <div style={styles.metricCard} className="metric-card">
      <h3 style={styles.metricNumber} className="metric-number">
        <AnimatedNumber value={82} />
      </h3>
      <p style={styles.metricLabel} className="metric-label">Cảm thấy được quan tâm sâu sắc hơn khi nhận hoa bất ngờ</p>
    </div>
    
    <div style={styles.metricCard} className="metric-card">
      <h3 style={styles.metricNumber} className="metric-number">
        <AnimatedNumber value={68} />
      </h3>
      <p style={styles.metricLabel} className="metric-label">Ghi nhớ lâu hơn và trân trọng những dịp kỷ niệm được tặng hoa</p>
    </div>
    
    <div style={styles.metricCard} className="metric-card">
      <h3 style={styles.metricNumber} className="metric-number">
        <AnimatedNumber value={76} />
      </h3>
      <p style={styles.metricLabel} className="metric-label">Ưu tiên lựa chọn các thương hiệu có dịch vụ giao nhanh trong ngày</p>
    </div>
    
    <div style={styles.metricCard} className="metric-card">
      <h3 style={styles.metricNumber} className="metric-number">
        <AnimatedNumber value={69} />
      </h3>
      <p style={styles.metricLabel} className="metric-label">Lựa chọn bó hoa có thiết kế đẹp nghệ thuật để lưu giữ khoảnh khắc</p>
    </div>
  </div>
</section>

      {/* 5. DỰ ÁN NỔI BẬT PARALLAX GRID & LOGO CHỮ KÝ */}
      <section style={styles.wideImageSection} className="wide-image-section">
        <motion.img src={shopWide} alt="Luxury Atelier" style={{ ...styles.parallaxImg, y: parallaxY }} />
        <div style={styles.centerLogoText} className="center-logo-text">Floraison your feelings</div>
      </section>

      {/* 6. DANH MỤC SẢN PHẨM PHÂN TÁCH CAO CẤP (LUXURY CATEGORY GRID) */}
      <section style={styles.productsSection} className="products-section">
        <div style={styles.productsHeader}>
          <span style={styles.editorialSub}>BỘ SƯU TẬP CỦA CHÚNG TÔI</span>
          <h2 style={styles.sectionTitle}>Danh mục sản phẩm hoa nghệ thuật</h2>
          
          {/* Tabs Thanh Lọc Bố Cục Thon Gọn */}
          <div style={styles.categoryTabsContainer} className="category-tabs-container">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                style={{
                  ...styles.categoryTabBtn,
                  color: activeCategory === cat.id ? "#111111" : "#888888",
                  borderBottom: activeCategory === cat.id ? "2px solid #4a5a3a" : "2px solid transparent",
                }}
                className="category-tab-btn"
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        {/* Lưới sản phẩm dạng Studio cao cấp */}
        <div style={styles.productsGrid} className="products-grid">
          {filteredFlowers.map((flower, idx) => (
            <motion.div 
              key={flower["Mã hoa"]} 
              initial={{ opacity: 0, y: 40 }} 
              whileInView={{ opacity: 1, y: 0 }} 
              viewport={{ once: true }} 
              transition={{ duration: 0.8, delay: (idx % 4) * 0.15 }} 
              style={styles.productCard}
              onMouseEnter={() => setHoveredId(flower["Mã hoa"])}
              onMouseLeave={() => setHoveredId(null)}
              onClick={() => openPopup(flower)}
            >
              <div style={styles.productImgWrapper}>
                <motion.img 
                  animate={{ scale: hoveredId === flower["Mã hoa"] ? 1.08 : 1 }} 
                  transition={{ duration: 0.8, ease: "easeOut" }} 
                  src={getFlowerImageUrl(flower["Mã hoa"])} 
                  alt={flower["Tên"]} 
                  style={styles.productImgCover} 
                />
                <div style={styles.productBadge}>
                  {categories.find((c) => c.id === activeCategory)?.name || "Atelier Exclusive"}
                </div>

                {/* Nền đen trong mờ Hover Overlay */}
                <AnimatePresence>
                  {hoveredId === flower["Mã hoa"] && (
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.4 }}
                      style={styles.hoverOverlay}
                    >
                      <motion.div initial={{ y: 20 }} animate={{ y: 0 }} exit={{ y: 10 }}>
                        <h4 style={styles.hoverProductName}>{flower["Tên"]}</h4>
                        <div style={styles.hoverPriceContainer}>
                          {flower["Giá sau khi giảm 25%"] ? (
                            <>
                              <span style={styles.hoverOldPrice}>{formatPrice(flower["Giá"])}</span>
                              <span style={styles.hoverNewPrice}>{formatPrice(flower["Giá sau khi giảm 25%"])}</span>
                            </>
                          ) : (
                            <span style={styles.hoverPrice}>{formatPrice(flower["Giá"])}</span>
                          )}
                        </div>
                        <p style={styles.hoverCta}>Khám phá chi tiết ✧</p>
                      </motion.div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* 7. CÂU CHUYỆN & CAM KẾT ĐẾN TỪ THƯƠNG HIỆU */}
      <section style={styles.storySection} className="story-section">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
          style={styles.storyContainer}
        >
          <span style={styles.scriptTitle} className="script-title">Câu chuyện tâm huyết</span>
          <h3 style={styles.storySubtitle} className="story-subtitle">Cam kết tối thượng từ Floraison</h3>
          <div style={styles.storyTextDivider} />
          <p style={styles.storyText} className="story-text">
            Floraison luôn đặt trải nghiệm sâu sắc và cảm xúc trọn vẹn của khách hàng lên hàng đầu. Chúng tôi tự hào cam kết mang đến những tác phẩm hoa tươi hoàn mỹ được tuyển chọn kỹ lưỡng, thiết kế chỉn chu chuẩn mực và tương thích với hình ảnh minh họa ở mức tối ưu nhất.
          </p>
          <p style={styles.storyText} className="story-text">
            Mỗi bó hoa trao đi không đơn thuần là món quà vật lý, mà là đại diện cho sự quan tâm chân thành và tình yêu thương thuần khiết gửi gắm đến người nhận. Vì vậy, chúng tôi đặc biệt chú trọng chất lượng độ tươi lâu của hoa, tốc độ giao nhận chuẩn xác trong 2 giờ cùng sự tinh tế tinh xảo ẩn chứa trong từng mối buộc.
          </p>
          <p style={styles.storyText} className="story-text">
            Dù là sự kiện trọng đại hay chỉ là khoảnh khắc bình dị thường nhật, Floraison mong muốn đồng hành để giúp bạn trao đi cảm xúc trọn vẹn, nhẹ nhàng và mang dấu ấn phong cách độc bản.
          </p>
          <div style={styles.contactHighlightBox}>
            Liên hệ ngay qua <span style={{ fontWeight: 600 }}>Zalo / Hotline: 0338 788 804</span> để nhận đặc quyền tư vấn thiết kế riêng.
          </div>
        </motion.div>
      </section>

      {/* 8. DARK FEATURE CAROUSEL - GLASSMORPHISM VOUCHER CHUYỂN ĐỘNG */}
      <section style={styles.darkFeatureSection} className="dark-feature-section">
        <AnimatePresence mode="wait">
          <motion.img
            key={currentFeatureSlide}
            src={featureSlides[currentFeatureSlide].bg}
            alt="Dark Floral Background Decor"
            initial={{ opacity: 0.5, scale: 1.08 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0.5 }}
            transition={{ duration: 1.2 }}
            style={styles.darkBgImg}
          />
        </AnimatePresence>
        <div style={styles.darkOverlay}></div>
        <div style={styles.darkFeatureContent}>
          <div style={styles.featureTextLeft} className="feature-text-left">
            <span style={styles.editorialSubGold}>Exclusive Gifts</span>
            <h2 style={styles.featureTitle} className="feature-title">Đặc quyền Floraison gửi tặng bạn</h2>

            <AnimatePresence mode="wait">
              <motion.div
                key={currentFeatureSlide}
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 30 }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
                style={styles.featureGlassBox}
                className="feature-glass-box"
              >
                <div style={styles.glassBoxLeftLine} />
                <p style={styles.featureHighlightText} className="feature-highlight-text">
                  {featureSlides[currentFeatureSlide].text}
                </p>
              </motion.div>
            </AnimatePresence>

            {/* Điều hướng kính xuyên thấu cho phần ưu đãi */}
            <div style={styles.featureGlassNav}>
              {featureSlides.map((_, idx) => (
                <div
                  key={idx}
                  onClick={() => setCurrentFeatureSlide(idx)}
                  style={{
                    ...styles.glassNavDot,
                    width: currentFeatureSlide === idx ? "28px" : "8px",
                    backgroundColor: currentFeatureSlide === idx ? "#d4af37" : "rgba(255,255,255,0.3)"
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 9. ĐÁNH GIÁ KHÁCH HÀNG THỰC TẾ (FEEDBACK ARCHITECTURE) */}
<section style={styles.feedbackSection} className="feedback-section">
  <div style={{ textAlign: 'center', marginBottom: '60px' }}>
    <span style={styles.editorialSub}>Khách hàng nói gì về Floraison?</span>
    <h2 style={styles.sectionTitle}>Được tin yêu bởi quý khách hàng</h2>
  </div>
  <div style={styles.feedbackGrid} className="feedback-grid">
    {[
      { name: "Mỹ Anh", role: "Khách hàng thân thiết", text: "Sự tinh tế trong cách phối màu của Floraison thực sự khác biệt so với các tiệm hoa thông thường. Hoa giữ form rất lâu và giao hàng đúng hẹn." },
      { name: "Trần Hiếu", role: "Doanh nhân", text: "Tôi luôn chọn hoa khai trương ở đây vì đối tác phản hồi rất tốt về tính sang trọng và quy mô chỉn chu của sản phẩm. Tư vấn nhiệt tình." },
      { name: "Hoàng Yến", role: "Khách hàng cá nhân", text: "Dịch vụ điện hoa 2h siêu tốc cứu cánh cho tôi những dịp lễ quan trọng. Tặng thiệp thiết kế kèm theo rất quý phái, đẳng cấp." },
      { name: "Minh Khang", role: "Khách hàng thiết kế", text: "Khả năng hỗ trợ thiết kế hoa theo yêu cầu riêng cực kỳ tốt. Đúng tone màu và đúng loại hoa hiếm mà tôi tìm kiếm." }
    ].map((item, idx) => (
      <motion.div
        key={idx}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        // Hiệu ứng xuất hiện ban đầu khi cuộn trang mượt hơn
        transition={{ duration: 0.6, delay: idx * 0.15, ease: "easeOut" }}
        style={styles.feedbackCard}
        className="feedback-card"
        // Thêm transition trực tiếp vào hover để phản hồi ngay lập tức (0.2 giây)
        whileHover={{ 
          y: -8, 
          boxShadow: "0 12px 30px rgba(0,0,0,0.06)",
          transition: { duration: 0.2, ease: "easeOut" }
        }}
      >
        <span style={styles.quoteIcon}>“</span>
        <p style={styles.feedbackText} className="feedback-text">{item.text}</p>
        
        {/* Bọc cụm thông tin bên dưới lại để cố định vị trí gạch ngang */}
        <div style={styles.feedbackFooter}>
          <div style={styles.feedbackUserDivider} />
          <h5 style={styles.feedbackUserName}>{item.name}</h5>
          <span style={styles.feedbackUserRole}>{item.role}</span>
        </div>
      </motion.div>
    ))}
  </div>
</section>

      {/* 10. ĐỘI NGŨ NGHỆ NHÂN LÀNH NGHỀ (WIDE TEAM BANNER) */}
      <section style={styles.teamSection} className="team-section">
        <div style={{ overflow: "hidden", width: "100%", height: "100%", position: 'relative' }}>
          <motion.img
            initial={{ scale: 1.08 }}
            whileInView={{ scale: 1 }}
            transition={{ duration: 1.8 }}
            src={teamWide}
            alt="Nghệ nhân Floraison sáng tạo nghệ thuật"
            style={styles.imgCover}
          />
          <div style={styles.teamOverlayBox}>
            <p style={styles.teamOverlayTitle}>Hoa tươi thay mới mỗi ngày</p>
          </div>
        </div>
      </section>

      {/* 11. ĐĂNG KÝ THÀNH VIÊN KHÁCH HÀNG THÂN THIẾT (PROMO BOTTOM) */}
<section style={styles.promoSection} className="promo-section">
  <motion.div
    initial={{ opacity: 0, scale: 0.98 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
    style={styles.promoBox}
    className="promo-box"
  >
    <h2 style={styles.promoTitle} className="promo-title">Nhận đặc quyền ưu đãi 25%</h2>
    <p style={styles.promoDesc} className="promo-desc">
      Trở thành hội viên VIP để cập nhật các bộ sưu tập theo mùa mới nhất, nhận thông tin các mẫu thiết kế vừa ra mắt và voucher chiết khấu riêng cho đơn hàng đầu tiên.
    </p>
    
    {/* Bọc trong thẻ <form> để tận dụng sự kiện onSubmit và phím Enter */}
    <form onSubmit={handleNewsletterSubmit} style={styles.inputActionWrapper} className="input-action-wrapper">
      <input
        type="email"
        placeholder="Nhập địa chỉ Email của bạn..."
        style={styles.luxuryInput}
        className="luxury-input"
        value={promoEmail}
        onChange={(e) => setPromoEmail(e.target.value)}
        disabled={isSubmitting}
        required
      />
      <button
        type="submit"
        style={{...styles.luxuryInputBtn, opacity: isSubmitting ? 0.7 : 1}}
        className="luxury-input-btn"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Đang xử lý..." : "Đăng ký trải nghiệm"}
      </button>
    </form>
  </motion.div>
</section>

      {/* ================= MODAL POPUP CHI TIẾT SẢN PHẨM ================= */}
      <AnimatePresence>
        {selectedFlower && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={styles.modalBackdrop}
            onClick={closePopup}
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0, y: 30 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.95, opacity: 0, y: 30 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              style={styles.modalContent}
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button style={styles.closeBtn} className="close-btn" onClick={closePopup}>✕</button>
              
              <div style={styles.modalLayout}>
                {/* Cột trái: Ảnh nền đen sang trọng */}
                <div style={styles.modalImageCol} className="modal-image-col">
                  <img 
                    src={getFlowerImageUrl(selectedFlower["Mã hoa"])} 
                    alt={selectedFlower["Tên"]} 
                    style={styles.modalImg} 
                  />
                </div>

                {/* Cột phải: Thông tin hoa phối viền ren */}
                <div style={styles.modalInfoCol} className="modal-info-col">
                  <span style={styles.modalBadge}>{selectedFlower["Hoa ở mục nào"]}</span>
                  <h3 style={styles.modalTitle} className="modal-title">{selectedFlower["Tên"]}</h3>

                  <div style={styles.modalPriceBox} className="modal-price-box">
                    {selectedFlower["Giá sau khi giảm 25%"] ? (
                      <>
                        <span style={styles.modalOldPrice}>{formatPrice(selectedFlower["Giá"])}</span>
                        <span style={styles.modalNewPrice}>{formatPrice(selectedFlower["Giá sau khi giảm 25%"])}</span>
                      </>
                    ) : (
                      <span style={styles.modalPrice}>{formatPrice(selectedFlower["Giá"])}</span>
                    )}
                  </div>

                  <div style={styles.modalDivider} className="modal-divider"></div>

                  <div style={styles.modalSection} className="modal-section">
                    <h5 style={styles.modalSectionTitle} className="modal-section-title">THÀNH PHẦN HOA</h5>
                    <p style={styles.modalDescText} className="modal-desc-text">{selectedFlower["Thành phần hoa"]}</p>
                  </div>

                  <div style={styles.modalSection} className="modal-section">
                    <h5 style={styles.modalSectionTitle} className="modal-section-title">CÂU CHUYỆN & CẢM HỨNG</h5>
                    <p style={styles.modalDescText} className="modal-desc-text">{selectedFlower["Mô tả"]}</p>
                  </div>

                  <button style={styles.addToCartBtn} className="add-to-cart-btn" onClick={() => addToCart(selectedFlower)}>Thêm vào giỏ hàng</button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ================= TOAST NOTIFICATION - LIQUID GLASS IOS STYLE ================= */}
      <AnimatePresence>
        {toast && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            style={{
              position: "fixed",
              top: "80px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 9999,
              pointerEvents: "none",
            }}
          >
            <div style={styles.toastContainer}>
              {toast}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
}

/* ================= JSS STYLING (PHONG CÁCH CHÂN THỰC LUXURY ATELIER) ================= */
const styles = {
  container: {
    fontFamily: '"Cormorant Garamond", serif',
    backgroundColor: "#ffffff",
    color: "#111111",
    overflowX: "hidden",
  },
  /* HIERARCHY TYPOGRAPHY CỔ ĐIỂN */
  sectionTitle: {
    fontSize: "clamp(26px, 3.5vw, 34px)",
    fontWeight: 400,
    textAlign: "center",
    letterSpacing: "3px",
    textTransform: "uppercase",
    color: "#1a1a1a",
    marginTop: "10px",
  },
  editorialSub: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "11px",
    fontWeight: 400,
    textTransform: "uppercase",
    letterSpacing: "4px",
    color: "#777777",
    display: "block",
    textAlign: "center",
  },
  editorialSubGold: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px",
    fontWeight: 400,
    textTransform: "uppercase",
    letterSpacing: "4px",
    color: "#d4af37",
    display: "block",
    marginBottom: "10px"
  },

  /* 1. HERO SECTION */
  heroSection: {
    position: "relative",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    backgroundColor: "#111111",
  },
  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    opacity: 0.95,
  },
  heroOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(to top, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.1) 40%, rgba(0, 0, 0, 0) 100%)",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    padding: "0 0 80px 6%",
  },
  heroTextContainer: {
    maxWidth: "85%",
    width: "max-content",
    textAlign: "left",
  },
  heroSub: {
    fontFamily: '"Pinyon Script", cursive',
    fontSize: "clamp(26px, 3.5vw, 36px)",
    color: "#d4af37",
    display: "block",
    marginBottom: "4px",
  },
  heroTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "clamp(20px, 3.2vw, 32px)",
    fontWeight: 400,
    color: "#ffffff",
    letterSpacing: "3px",
    lineHeight: "1.6",
    whiteSpace: "pre",
    wordBreak: "keep-all",
    marginBottom: "30px",
    textTransform: "uppercase",
    textShadow: "0 2px 12px rgba(0, 0, 0, 0.25)",
  },
  heroBtn: {
    padding: "12px 32px",
    backgroundColor: "transparent",
    border: "1px solid rgba(255, 255, 255, 0.8)",
    color: "#ffffff",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "10px",
    textTransform: "uppercase",
    letterSpacing: "3px",
    cursor: "pointer",
    transition: "all 0.4s ease",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
  },
  /* ĐIỀU HƯỚNG KÍNH (GLASSMORPHISM) */
  glassNavContainer: {
    position: "absolute",
    bottom: "35px",
    left: "6%",
    transform: "none",
    display: "flex",
    gap: "10px",
    padding: "10px 16px",
    background: "rgba(255, 255, 255, 0.08)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    borderRadius: "40px",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
    zIndex: 10,
  },
  glassNavDot: {
    height: "6px",
    borderRadius: "3px",
    cursor: "pointer",
    transition: "all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  },
  timelineWrapper: {
    position: "absolute",
    bottom: "43px",
    right: "6%",
    width: "140px",
    height: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    overflow: "hidden",
    zIndex: 10,
  },
  timelineBar: {
    height: "100%",
    backgroundColor: "#ffffff",
  },

  /* 2. CORE BADGES SECTION */
  badgeSection: {
    padding: "60px 8%",
    backgroundColor: "#ffecf9",
    borderBottom: "1px solid #eaeaea",
  },
  badgeGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "40px",
  },
  badgeItem: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  badgeIcon: {
    fontSize: "18px",
    color: "#4a5a3a",
    display: "block",
    marginBottom: "12px",
  },
  badgeTitle: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: "2px",
    marginBottom: "8px",
    color: "#222222",
    whiteSpace: "nowrap",
  },
  badgeDesc: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px",
    color: "#666666",
    lineHeight: "1.6",
    whiteSpace: "pre-line",
    wordBreak: "keep-all",
    maxWidth: "280px",
    margin: "0 auto",
  },

  /* 3. ABOUT SECTION - EDITORIAL GRID */
  aboutSection: {
    padding: "120px 8%",
    backgroundColor: "#ffffff",
  },
  aboutGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "60px",
    alignItems: "center",
  },
  aboutImgCol: {
    position: "relative",
    aspectRatio: "4/5",
    overflow: "hidden",
  },
  aboutImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  aboutImgFloatingTag: {
    position: "absolute",
    bottom: "30px",
    right: "30px",
    backgroundColor: "#ffffff",
    padding: "10px 20px",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "11px",
    letterSpacing: "2px",
    textTransform: "uppercase",
    border: "1px solid #111111",
    whiteSpace: "nowrap",
  },
  aboutTextCol: {
    paddingLeft: "20px",
    maxWidth: "100%",
  },
  editorialTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "clamp(26px, 3.8vw, 38px)",
    fontWeight: 400,
    letterSpacing: "1px",
    lineHeight: "1.4",
    margin: "15px 0 30px 0",
    textTransform: "uppercase",
    whiteSpace: "pre-line",
    wordBreak: "keep-all",
  },
  aboutParagraph: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13.5px",
    lineHeight: "1.9",
    color: "#444444",
    marginBottom: "25px",
    whiteSpace: "pre-line",
    wordBreak: "keep-all",
  },
  classicLinkBtn: {
    backgroundColor: "transparent",
    border: "1px solid #111111",
    color: "#111111",
    padding: "14px 36px",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "11px",
    letterSpacing: "2px",
    textTransform: "uppercase",
    cursor: "pointer",
    fontWeight: 500,
    display: "inline-block",
    marginTop: "20px",
    whiteSpace: "nowrap",
    transition: "background-color 0.4s ease, color 0.4s ease, border-color 0.4s ease",
  },

  /* 4. METRICS SECTION */
  metricsSection: {
    backgroundColor: "#4a5a3a",
    color: "#ffffff",
    padding: "80px 8%",
  },
  metricsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "40px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  metricCard: {
    textAlign: "center",
    borderRight: "1px solid rgba(255,255,255,0.15)",
    padding: "0 15px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  metricNumber: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "clamp(45px, 5vw, 65px)",
    fontWeight: 300,
    marginBottom: "10px",
    color: "#fafafa",
  },
  metricLabel: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px",
    lineHeight: "1.6",
    color: "#e0e8db",
    letterSpacing: "0.5px",
  },

  /* 5. WIDE PARALLAX IMAGE */
  wideImageSection: {
    position: "relative",
    width: "100%",
    height: "65vh",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  parallaxImg: {
    position: "absolute",
    top: "-80px",
    left: 0,
    width: "100%",
    height: "140%",
    objectFit: "cover",
    zIndex: 1,
  },
  centerLogoText: {
    position: "relative",
    zIndex: 2,
    fontFamily: '"Pinyon Script", cursive',
    fontSize: "clamp(55px, 7vw, 105px)",
    color: "#ffffff",
    textShadow: "0 6px 25px rgba(0,0,0,0.4)",
  },

  /* 6. PRODUCTS CATEGORY SECTION */
  productsSection: {
    padding: "120px 6%",
    backgroundColor: "#ffffff",
  },
  productsHeader: {
    marginBottom: "60px",
    textAlign: "center"
  },
  categoryTabsContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "25px",
    marginTop: "35px",
    borderBottom: "1px solid #f0f0f0",
    paddingBottom: "15px",
  },
  categoryTabBtn: {
    background: "none",
    border: "none",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    cursor: "pointer",
    padding: "8px 4px",
    transition: "all 0.3s ease",
  },
  productsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "3px 3px",
  },
  productCard: {
    position: "relative",
    cursor: "pointer",
    overflow: "hidden",
  },
  productImgWrapper: {
    position: "relative",
    width: "100%",
    aspectRatio: "3/4",
    overflow: "hidden",
    backgroundColor: "#000000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  productImgCover: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    padding: "25px",
  },
  productBadge: {
    position: "absolute",
    top: "15px",
    left: "15px",
    backgroundColor: "rgba(255,255,255,0.9)",
    color: "#111",
    padding: "6px 12px",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "9px",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    zIndex: 2,
  },
  hoverOverlay: {
    position: "absolute",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(10, 10, 10, 0.75)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    textAlign: "center",
    zIndex: 3,
    backdropFilter: "blur(5px)",
    WebkitBackdropFilter: "blur(5px)",
  },
  hoverProductName: {
    fontFamily: '"Cormorant Garamond", serif',
    color: "#ffffff",
    fontSize: "24px",
    fontWeight: "400",
    letterSpacing: "1px",
    marginBottom: "15px",
  },
  hoverPriceContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginBottom: "20px",
  },
  hoverPrice: {
    color: "#d4af37",
    fontSize: "16px",
    fontFamily: '"Montserrat", sans-serif',
  },
  hoverOldPrice: {
    color: "#888",
    fontSize: "14px",
    textDecoration: "line-through",
    fontFamily: '"Montserrat", sans-serif',
  },
  hoverNewPrice: {
    color: "#d4af37",
    fontSize: "16px",
    fontWeight: "600",
    fontFamily: '"Montserrat", sans-serif',
  },
  hoverCta: {
    color: "#ffffff",
    fontSize: "11px",
    textTransform: "uppercase",
    letterSpacing: "2px",
    borderBottom: "1px solid #d4af37",
    paddingBottom: "4px",
  },

  /* STYLE CHO MODAL (POPUP SANG TRỌNG) */
  modalBackdrop: {
    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
    backgroundColor: "rgba(254, 228, 245, 0.52)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    zIndex: 9999,
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: "30px"
  },
  modalContent: {
    position: "relative",
    width: "100%", maxWidth: "1000px", height: "85vh",
    backgroundColor: "#ffffff",
    display: "flex",
    overflow: "hidden",
    boxShadow: "0 25px 60px rgba(0,0,0,0.6)",
  },
  closeBtn: {
    position: "absolute", top: "25px", right: "25px",
    background: "transparent", border: "none",
    fontSize: "26px", color: "#111111", cursor: "pointer", zIndex: 10,
    transition: "transform 0.3s ease",
  },
  modalLayout: {
    display: "flex", width: "100%", height: "100%"
  },
  modalImageCol: {
    flex: "1 1 50%",
    backgroundColor: "#000000",
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: "50px"
  },
  modalImg: {
    width: "100%", height: "100%", objectFit: "contain"
  },
  modalInfoCol: {
    flex: "1 1 50%",
    padding: "60px 50px",
    backgroundColor: "#faf9f8",
    overflowY: "auto",
    position: "relative",
    backgroundImage: "url('/Ren hoa san pham.jpg')",
    backgroundSize: "cover",
    backgroundBlendMode: "overlay",
  },
  modalBadge: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "10px", letterSpacing: "2.5px", color: "#888",
    textTransform: "uppercase", marginBottom: "15px", display: "inline-block"
  },
  modalTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "38px", fontWeight: "400", color: "#111",
    marginBottom: "20px", lineHeight: "1.2"
  },
  modalPriceBox: {
    marginBottom: "30px", display: "flex", gap: "15px", alignItems: "center"
  },
  modalPrice: {
    fontFamily: '"Montserrat", sans-serif', fontSize: "22px", color: "#4a5a3a", fontWeight: "500"
  },
  modalOldPrice: {
    fontFamily: '"Montserrat", sans-serif', fontSize: "16px", color: "#999", textDecoration: "line-through"
  },
  modalNewPrice: {
    fontFamily: '"Montserrat", sans-serif', fontSize: "22px", color: "#d4af37", fontWeight: "600"
  },
  modalDivider: {
    width: "50px", height: "1px", backgroundColor: "#d4af37", margin: "30px 0"
  },
  modalSection: {
    marginBottom: "30px"
  },
  modalSectionTitle: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px", letterSpacing: "2px", color: "#111", marginBottom: "12px", textTransform: "uppercase"
  },
  modalDescText: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13.5px", color: "#555", lineHeight: "1.8", whiteSpace: "pre-line", textAlign: "justify"
  },
  addToCartBtn: {
    marginTop: "25px", width: "100%", padding: "18px 0",
    backgroundColor: "#111111", color: "#ffffff", border: "none",
    fontFamily: '"Montserrat", sans-serif', textTransform: "uppercase",
    letterSpacing: "2px", fontSize: "12px", fontWeight: "500",
    cursor: "pointer", transition: "background 0.3s ease",
  },

  /* 7. STORY TEXT SECTIONS */
  storySection: {
    padding: "120px 8%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#faf6f0",
  },
  storyContainer: {
    maxWidth: "850px",
    textAlign: "center",
  },
  scriptTitle: {
    fontFamily: '"Pinyon Script", cursive',
    fontSize: "clamp(55px, 6vw, 85px)",
    color: "#4a5a3a",
    margin: "0 0 -15px 0",
    display: "block",
  },
  storySubtitle: {
    fontSize: "26px",
    textTransform: "uppercase",
    letterSpacing: "4px",
    fontWeight: 400,
    marginBottom: "25px",
    color: "#222222",
  },
  storyTextDivider: {
    width: "60px",
    height: "1px",
    backgroundColor: "#4a5a3a",
    margin: "0 auto 35px auto",
  },
  storyText: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13.5px",
    lineHeight: "2",
    color: "#444444",
    marginBottom: "25px",
    textAlign: "justify",
  },
  contactHighlightBox: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13px",
    border: "1px dashed #4a5a3a",
    padding: "20px",
    marginTop: "40px",
    letterSpacing: "0.5px",
    backgroundColor: "rgba(255,255,255,0.5)",
  },

  /* 8. DARK FEATURE SECTION WITH GLASSMORPHISM */
  darkFeatureSection: {
    position: "relative",
    width: "100%",
    padding: "160px 8%",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    color: "#ffffff",
    backgroundColor: "#0f140d",
  },
  darkBgImg: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: 1,
  },
  darkOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(15, 20, 13, 0.75)",
    zIndex: 2,
  },
  darkFeatureContent: {
    position: "relative",
    zIndex: 3,
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
  },
  featureTextLeft: {
    maxWidth: "650px",
  },
  featureTitle: {
    fontSize: "clamp(26px, 4vw, 38px)",
    fontWeight: 300,
    textTransform: "uppercase",
    letterSpacing: "2px",
    marginBottom: "35px",
  },
  featureGlassBox: {
    position: "relative",
    background: "rgba(255, 255, 255, 0.06)",
    backdropFilter: "blur(25px)",
    WebkitBackdropFilter: "blur(25px)",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    padding: "35px 40px",
    borderRadius: "4px",
    minHeight: "140px",
    display: "flex",
    alignItems: "center",
    boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
  },
  glassBoxLeftLine: {
    position: "absolute",
    left: 0,
    top: "15%",
    bottom: "15%",
    width: "3px",
    backgroundColor: "#d4af37",
  },
  featureHighlightText: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "15px",
    lineHeight: "1.8",
    letterSpacing: "0.8px",
    margin: 0,
    whiteSpace: "pre-line",
  },
  featureGlassNav: {
    display: "flex",
    gap: "10px",
    marginTop: "35px"
  },

  /* 9. FEEDBACK TESTIMONIALS SECTION */
  feedbackSection: {
    padding: "120px 8%",
    backgroundColor: "#ffffff",
  },
  feedbackGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "30px",
  },
  feedbackCard: {
    border: "1px solid #eeeeee",
    padding: "40px 30px",
    backgroundColor: "#ffffff",
    borderRadius: "2px",
    textAlign: "center",
    // Loại bỏ 'all 0.4s' để tránh xung đột làm chậm hiệu ứng của Framer Motion
    transition: "border-color 0.3s ease, background-color 0.3s ease",
    
    // Biến card thành trục flexbox dọc để cân bằng khoảng trống bên trong
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  quoteIcon: {
    fontSize: "45px",
    fontFamily: "serif",
    color: "#4a5a3a",
    display: "block",
    lineHeight: "1",
    marginBottom: "-10px",
  },
  feedbackText: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13px",
    lineHeight: "1.8",
    color: "#555555",
    fontStyle: "italic",
    marginBottom: "25px",
    // Chiếm trọn không gian trống còn thừa để đẩy phần footer đồng đều xuống đáy card
    flexGrow: 1,
  },
  // Khối bao bọc mới giúp neo giữ vị trí các phần tử bên dưới luôn thẳng hàng
  feedbackFooter: {
    marginTop: "auto",
    width: "100%",
  },
  feedbackUserDivider: {
    width: "30px",
    height: "1px",
    backgroundColor: "#ddd",
    margin: "0 auto 15px auto",
  },
  feedbackUserName: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13px",
    fontWeight: 500,
    color: "#111111",
    marginBottom: "2px",
  },
  feedbackUserRole: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "11px",
    color: "#999999",
    letterSpacing: "1px",
  },

  /* 10. TEAM SECTION */
  teamSection: {
    width: "100%",
    height: "60vh",
    backgroundColor: "#111",
  },
  imgCover: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  teamOverlayBox: {
    position: "absolute",
    bottom: "40px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "rgba(17, 17, 17, 0.8)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    padding: "15px 35px",
    border: "1px solid rgba(255,255,255,0.1)",
  },
  teamOverlayTitle: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px",
    color: "#ffffff",
    letterSpacing: "3px",
    textTransform: "uppercase",
    margin: 0,
  },

  /* 11. PROMO / NEWSLETTER BOTTOM */
  promoSection: {
    padding: "120px 8%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#fafafa",
  },
  promoBox: {
    textAlign: "center",
    maxWidth: "900px",
    width: "100%",
  },
  promoTitle: {
    fontSize: "28px",
    letterSpacing: "3px",
    fontWeight: 400,
    textTransform: "uppercase",
    marginBottom: "15px"
  },
  promoDesc: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "13px",
    lineHeight: "1.8",
    color: "#555",
    marginBottom: "40px"
  },
  inputActionWrapper: {
    display: "flex",
    gap: "10px",
    justifyContent: "center"
  },
  luxuryInput: {
    width: "60%",
    padding: "14px 20px",
    border: "1px solid #ccc",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px",
    outline: "none"
  },
  luxuryInputBtn: {
    padding: "14px 30px",
    backgroundColor: "#111",
    color: "#fff",
    border: "none",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "2px",
    cursor: "pointer",
    transition: "background 0.3s"
  },

  /* TOAST NOTIFICATION - LIQUID GLASS IOS STYLE */
  toastContainer: {
  position: "absolute",
  zIndex: "9999",
  top: "20px",                  
  left: "50%",                  
  transform: "translateX(-50%)",
  
  // --- THẦN CHÚ ÉP RENDER BLUR NGAY TỪ ĐẦU ---
  willChange: "backdrop-filter, transform", 
  transformStyle: "preserve-3d",
  backfaceVisibility: "hidden",
  // ------------------------------------------

  backgroundColor: "rgba(255, 255, 255, 0.15)",
  backdropFilter: "blur(12px) saturate(180%)",
  WebkitBackdropFilter: "blur(12px) saturate(180%)",
  
  border: "1px solid rgba(255, 255, 255, 0.25)",
  borderRadius: "50px",
  padding: "14px 28px",
  color: "#000000",
  fontFamily: '"Montserrat", sans-serif',
  fontSize: "14px",
  fontWeight: "500",
  letterSpacing: "0.5px",
  textAlign: "center",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 1px rgba(255, 255, 255, 0.2)",
  
  // === TỐI ƯU CHO MOBILE & TABLET (BAO BỌC NỘI DUNG) ===
  width: "max-content",      // Tự co giãn theo chữ nếu thông báo ngắn
  maxWidth: "85vw",          // Không vượt quá 85% chiều rộng màn hình thiết bị nhỏ
  whiteSpace: "normal",      // Cho phép chữ xuống dòng thay vì tràn ra ngoài màn hình
  wordBreak: "break-word",   // Ngắt từ thông minh khi xuống hàng
  lineHeight: "1.4",         // Giúp khoảng cách giữa các dòng chữ dễ đọc hơn khi xuống hàng
}
};